import React from "react"
import { useInheritedTheme } from "../hooks/use-theme"
import useThemeAndStyle from "../hooks/use-theme-and-style"
import typographyStyles from "../utils/typography-styles"
import SlateNode from "../slate-nodes/slate-node"

const Block = ({ tag, node, ...props }) => {
  const { find } = useInheritedTheme()
  const style = useThemeAndStyle(tag, {
    ...typographyStyles(tag, find),
    textAlign: node.data.get("alignment") || find(tag, "textAlign"),
    ...props.style
  })

  return <SlateNode as={tag} node={node} {...props} style={style} />
}

export default () => {
  return {
    renderNode(props, editor, next) {
      const { attributes, children, node } = props

      switch (node.type) {
        case "heading-one":
          return (
            <Block tag="h1" node={node} {...attributes}>
              {children}
            </Block>
          )
        case "heading-two":
          return (
            <Block tag="h2" node={node} {...attributes}>
              {children}
            </Block>
          )
        case "heading-three":
          return (
            <Block tag="h3" node={node} {...attributes}>
              {children}
            </Block>
          )
        case "heading-four":
          return (
            <Block tag="h4" node={node} {...attributes}>
              {children}
            </Block>
          )
        case "heading-five":
          return (
            <Block tag="h5" node={node} {...attributes}>
              {children}
            </Block>
          )
        case "heading-six":
          return (
            <Block tag="h6" node={node} {...attributes}>
              {children}
            </Block>
          )

        case "horizontal-rule":
          return <Block tag="hr" node={node} {...attributes} />
        default:
          return next()
      }
    }
  }
}
